export { PassFailTag, type PassFailTagProps } from './PassFailTag';
